import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { PoModalModule, PoModule } from '@po-ui/ng-components';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { PoModalPasswordRecoveryModule } from '@po-ui/ng-templates';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule, YouTubePlayerModule, PoModalModule, PoModalPasswordRecoveryModule, PoModule, FormsModule
  ]
})
export class LoginModule { }
